export default __webpack_public_path__ + "static/media/salary3.cf50441a.png";